import inputNumber from './input-number';
import inputPwd from './input-pwd';

export default {
    install(Vue, options) {
        Vue.directive('inputNumber',inputNumber);
        Vue.directive('inputPwd',inputPwd);
       
    }
}


// WEBPACK FOOTER //
// ./src/directives/index.js